import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * SP4c — /auth/callback route. Auth0 redirects here after Universal Login.
 *
 * The Auth0Provider has its own internal handler for the OAuth2 code-grant
 * URL params (?code=...&state=...) that fires before this component renders.
 * Once the provider transitions to isAuthenticated=true, we navigate to the
 * original page the user wanted (carried in appState.returnTo).
 *
 * The Auth0CookieSync (mounted at the app root) handles writing the access
 * token to the cookie — no work here.
 */
export default function CallbackPage() {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (error) return;
    if (isAuthenticated) {
      // Auth0Provider serializes appState.returnTo into its own state; the
      // SDK's `onRedirectCallback` consumes it. Default fallback is "/".
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, isLoading, error, navigate]);

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-red-600">
          Auth0 login failed: {error.message}
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center">
      <div>Completing sign-in…</div>
    </div>
  );
}
